/* eslint-disable react/require-default-props */
import { Grid, Typography } from '@mui/material';

import {
  convertConcept,
  convertPropertyType,
  convertRegistrationUf,
} from '../../../api/enumerations';
import { WorkOrderData } from '../../../api/workOrders/types';
import { IconDownloadMS } from '../../../constants/icons';
import { DownloadButton } from '../../UI/Button';
import { InputTitle, SmallStyledInput } from '../../UI/Typography';
import { Constants } from './constants';
import { ButtonBox, ButtonContainer, ButtonTitle } from './styles';

interface PropertyDataProps {
  propertyData?: WorkOrderData;
}

export function PropertyData({ propertyData }: PropertyDataProps): JSX.Element {
  const registerFileVerify =
    propertyData?.real_estate_registry === null ||
    !propertyData?.real_estate_registry;
  const iptuFileVerify =
    propertyData?.iptu_document === null || !propertyData?.iptu_document;

  const downloadFile = (dataLink: string, name: string): void => {
    const linkSource = dataLink;
    const downloadLink = document.createElement('a');
    downloadLink.href = linkSource;
    downloadLink.download = name;
    downloadLink.click();
  };

  return (
    <>
      <Typography>{Constants.downloadText}</Typography>
      <ButtonContainer>
        <ButtonBox>
          <ButtonTitle>{Constants.propertyRegister}</ButtonTitle>
          <DownloadButton
            disabled={registerFileVerify}
            onClick={() => {
              if (propertyData?.real_estate_registry) {
                downloadFile(propertyData.real_estate_registry, 'matricula');
              }
            }}
          >
            {IconDownloadMS}
            {Constants.download}
          </DownloadButton>
        </ButtonBox>
        <ButtonBox>
          <ButtonTitle>{Constants.iptu}</ButtonTitle>
          <DownloadButton
            disabled={iptuFileVerify}
            onClick={() => {
              if (propertyData?.iptu_document) {
                downloadFile(propertyData.iptu_document, 'iptu');
              }
            }}
          >
            {IconDownloadMS}
            {Constants.download}
          </DownloadButton>
        </ButtonBox>
      </ButtonContainer>
      <Grid container spacing={4}>
        <Grid item xs={3}>
          <InputTitle>{Constants.registerNumber}</InputTitle>
          <SmallStyledInput>
            {propertyData?.registration_number}
          </SmallStyledInput>
        </Grid>
        <Grid item xs={3}>
          <InputTitle>{Constants.registryOffice}</InputTitle>
          <SmallStyledInput>{propertyData?.registry_office}</SmallStyledInput>
        </Grid>
        <Grid item xs={3}>
          <InputTitle>{Constants.book}</InputTitle>
          <SmallStyledInput>{propertyData?.book}</SmallStyledInput>
        </Grid>
        <Grid item xs={3}>
          <InputTitle>{Constants.propertyType}</InputTitle>
          <SmallStyledInput>
            {propertyData && convertPropertyType(propertyData.real_estate_kind)}
          </SmallStyledInput>
        </Grid>
        <Grid item xs={3}>
          <InputTitle>{Constants.concept}</InputTitle>
          <SmallStyledInput>
            {propertyData && convertConcept(propertyData.communities_kind)}
          </SmallStyledInput>
        </Grid>
        <Grid item xs={3}>
          <InputTitle>{Constants.zone}</InputTitle>
          <SmallStyledInput>{propertyData?.zone}</SmallStyledInput>
        </Grid>
        <Grid item xs={3}>
          <InputTitle>{Constants.judicialDistrict}</InputTitle>
          <SmallStyledInput>{propertyData?.judicial_district}</SmallStyledInput>
        </Grid>
        <Grid item xs={3}>
          <InputTitle>{Constants.registrationUf}</InputTitle>
          <SmallStyledInput>
            {propertyData && convertRegistrationUf(propertyData.uf)}
          </SmallStyledInput>
        </Grid>
      </Grid>
    </>
  );
}
